import React from 'react';
import Top_Banner_All from '../assests/Top_Banner_All.jpg';
import Man_Boxing from '../assests/man-boxing.jpg';
import Woman_Yoga from '../assests/woman-yoga.jpg';
import Man_Combat from '../assests/man-body-combat.jpeg';
import Woman_Cardio from '../assests/woman-cardio.webp';
import Man_Crossfit from '../assests/man-crossfit.jpg';
import Man_Strength from '../assests/man-strength.jpg';
import Man_WorkOut from '../assests/man-workout.jpg';
import Man_PowerLift from '../assests/man-powerlift.jpg';

const Card = ({ title, instructor, time, image }) => {

  const pageHandler =()=> {
    window.location.href = "/contact";
  }
    return (
        <div className="card" style={{ backgroundImage: `url(${image})` }}>
            <div className="card-content">
                <h3>{title}</h3>
                <div className="card-info">
                    <div className="card-column">
                        <i className="fas fa-user"></i> {instructor}
                    </div>
                    <div className="card-column">
                        <i className="fas fa-clock"></i> {time}
                    </div>
                </div>
                <button className="card-button" onClick={pageHandler}>JOIN NOW</button>
            </div>
        </div>
    );
};


const Classes = () => {

  const classes = [
    { title: 'Yoga', instructor: 'Jane Doe', time: 'Mon: 8:00 am', image: Woman_Yoga },
    { title: 'Boxing', instructor: 'John Flex', time: 'Tue: 4:00 pm', image: Man_Boxing },
    { title: 'Combat Techniques', instructor: 'Marv Smith', time: 'Wed: 9:00 am', image: Man_Combat },
    { title: 'Cardio', instructor: 'Linda White', time: 'Thu: 7:00 am', image: Woman_Cardio },
    { title: 'Crossfit', instructor: 'Mike Johnson', time: 'Fri: 6:00 pm', image: Man_Crossfit },
    { title: 'Workout', instructor: 'Shawn Ray', time: 'Fri: 6:00 pm', image: Man_WorkOut },
    { title: 'Power Lifting', instructor: 'Larry Wheels', time: 'Fri: 6:00 pm', image: Man_PowerLift },
    { title: 'Strength', instructor: 'David Brown', time: 'Sat: 10:00 am', image: Man_Strength },
];

  return (
    <>
      <section className='pricing-section'>
          <div className="header-image-container">
          <header className={`pricing-header`}>
          <img src={Top_Banner_All} alt="Pricing Background" className="pricing-img" />
          <h1 className="pricing-title">Classes</h1>
          </header>
          </div>
          <div className="cards-container">
            <h1 className="cards-heading">Our Classes</h1>
            {/* <br /> */}
              {classes.map((classInfo, index) => (
                  <Card
                      key={index}
                      title={classInfo.title}
                      instructor={classInfo.instructor}
                      time={classInfo.time}
                      image={classInfo.image}
                  />
              ))}
          </div>
      </section>
    </>
  )
}

export default Classes;
